<div class="container">
  <div class="controls">
    <input #urlInput type="text" placeholder="SCORM entry point URL" value="https://simui-dev.quantified.ai/assets/scorm/launchpage.html" (keyup.enter)="handleUrlInputKeydown($event)" />
    <button type="button" (click)="onLoad()">Load</button>
  </div>
  <iframe [src]="safeUrl"></iframe>
</div>
